module.exports = __webpack_public_path__ + "static/media/kas_logo.e7625fb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/header/kas_logo.png
// module id = 532
// module chunks = 0